import React, { useState, useEffect } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

function Timer({ duration, isActive, onExpire }) {
    const [seconds, setSeconds] = useState(duration);

    useEffect(() => {
        let timerId = null;
        if (isActive && seconds > 0) {
            timerId = setTimeout(() => setSeconds(seconds - 1), 1000);
        } else if (seconds === 0 && isActive) {
            onExpire(); // Call the callback function when the timer expires
        }

        return () => clearTimeout(timerId);
    }, [seconds, isActive, onExpire]);

    const percentage = (seconds / duration) * 100;

    function secondsToMinutesSeconds(seconds) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');
        return `${formattedMinutes}:${formattedSeconds}`;
      }

    return (
        <div style={{ width: '60px', height: '60px', float: 'right' }}>
            <CircularProgressbar
                value={percentage}
                text={secondsToMinutesSeconds(seconds)}
                strokeWidth={12}
                styles={buildStyles({
                    pathColor: `rgba(255, 0, 0, ${percentage / 100})`,
                    textColor: '#3e98c7',
                    textSize: '30px'
                })}
            />
        </div>
    );
}

export default Timer;
